import React from 'react';
import { Flex } from 'antd';

import { SlackUser } from 'jf/api';
import { useDevExTheme } from 'jf/common/themes/DevExTheme';

import { SlackTargetSearch } from './SlackTargetSearch';
import { SlackTargetTagList } from './SlackTargetTagList';

type SlackTargetModalEditorProps = {
  studyRef: string;
  unsavedSlackTargets: SlackUser[];
  onChange: (slackTargets: SlackUser[]) => void;
};

// deprecating for MS Teams
export const SlackTargetModalEditor = (props: SlackTargetModalEditorProps) => {
  const theme = useDevExTheme();

  return (
    <Flex vertical gap={theme.variable.spacing.md}>
      <SlackTargetSearch
        unsavedSlackTargets={props.unsavedSlackTargets}
        onChange={props.onChange}
        studyRef={props.studyRef}
      />

      <SlackTargetTagList
        unsavedSlackTargets={props.unsavedSlackTargets}
        onChange={props.onChange}
        studyRef={props.studyRef}
      />
    </Flex>
  );
};
